import React from 'react';

import { Card } from '../components';
import UserFormFields from '../users/UserFormFields';

const UserCard = ({ source, record, permissions, isAgent, ...props }) => (
	<Card {...props} source={source}>
		<UserFormFields
			permissions={permissions}
			record={record}
			resource="users"
			source={source}
			roles={[]}
			isAgent={isAgent}
			chooseAgent={false}
		/>
	</Card>
);

UserCard.defaultProps = {
	source: 'user'
};

export default UserCard;
